import type { CartItem } from "../contexts/cartContext";
import { supabase } from "../utils/supabaseClient";

const BASE_URL = process.env.REACT_APP_API_URL ?? "";

export const createCheckoutSession = async (items: CartItem[]) => {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const res = await fetch(`${BASE_URL}/api/v1/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session?.access_token ?? ""}`,
    },
    body: JSON.stringify({
      items: items.map((i) => ({
        product_id: i.variant.id,
        size: i.variant.size,
        quantity: i.quantity,
      })),
      success_url: `${window.location.origin}/purchase?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: window.location.origin,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail ?? "Checkout failed");
  }

  return res.json() as Promise<{ session_id: string; url: string }>;
};
